import React from "react";
import AddUser from "../components/AddUser/AddUser";

const AddUserPage = () => {
  return <AddUser />;
};

export default AddUserPage;
